import * as o from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/DotsSixVertical.es.js";
const t = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(a, { ref: r, ...e, weights: i }));
t.displayName = "DotsSixVerticalIcon";
const m = t;
export {
  m as DotsSixVertical,
  t as DotsSixVerticalIcon
};
